import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {PaymentRequestSummaryModel} from '../paymentRequestSummary.model';
import {EntityWithAuditMetadataConverter} from '../../../../../../common/converter/entityWithAuditMetadata.converter';
import {PartnerSummaryConverter} from '../../../../../../partner/common/api/converter/partnerSummary.converter';
import {
    AccountingMovementSummaryConverter
} from '../../../../../../accounting/movement/api/entity/converter/accountingMovementSummary.converter';
import {Injectable} from '@angular/core';
import {UserSummaryConverter} from "../../../../../../account/modules/user/api/converter/userSummary.converter";
import {OfficeSummaryConverter} from "../../../../../../office/api/model/converter/officeSummary.converter";
import {DocumentSummaryConverter} from "../../../../../../document/common/api/converter/documentSummary.converter";

@Injectable({providedIn: 'root'})
export class PaymentRequestSummaryConverter extends HttpModelConverter<PaymentRequestSummaryModel> {

    constructor(private lovValueConverter: LovValueSummaryConverter,
                private partnerSummaryConverter: PartnerSummaryConverter,
                private accountingMovementSummaryConverter: AccountingMovementSummaryConverter,
                private entityWithAuditMetadataConverter: EntityWithAuditMetadataConverter,
                private u: UserSummaryConverter,
                private o: OfficeSummaryConverter,
                private documentSummaryConverter: DocumentSummaryConverter) {
        super();
    }

    protected createInstance(): PaymentRequestSummaryModel {
        return new PaymentRequestSummaryModel();
    }

    protected enrichObject(result: PaymentRequestSummaryModel, src: PaymentRequestSummaryModel) {
        result.status = this.lovValueConverter.convert(src.status);
        result.direction = this.lovValueConverter.convert(src.direction);
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.responsible = this.u.convert(src.responsible);
        result.office = this.o.convert(src.office);
        result.thirdPartyPartner = this.partnerSummaryConverter.convert(src.thirdPartyPartner);
        result.thirdPartyPaymentType = this.lovValueConverter.convert(src.thirdPartyPaymentType);
        result.accountingMovements = this.accountingMovementSummaryConverter.convertFromArray(src.accountingMovements);
        result.document = this.documentSummaryConverter.convert(src.document)
        this.entityWithAuditMetadataConverter.convert(result, src);
    }
}
